import PropTypes from 'prop-types';
import classNames from 'classnames';

import { INFO, METAMASK, BROWSER_SUPPORT, NO_INTERNET_CONNECTION } from 'constants/dialogs';
import { useLockBody } from 'utils/hooks';
import Icon from 'components/icon';
import Portal from 'components/portal';
import Button from 'components/button';

import infoIcon from 'assets/images/info_icon.svg';
import noNetworkIcon from 'assets/images/Error-message.svg';
import metamaskIcon from 'assets/images/metamask-icon.png';
import browserSupportIcon from 'assets/images/MetaMask-browser-not-supported.svg';

export const dialogImages = {
  [INFO]: {
    src: infoIcon,
    alt: 'info',
  },
  [METAMASK]: {
    src: metamaskIcon,
    alt: 'metamask',
  },
  [BROWSER_SUPPORT]: {
    src: browserSupportIcon,
    alt: 'browser support',
  },
  [NO_INTERNET_CONNECTION]: {
    src: noNetworkIcon,
    alt: 'no network',
  },
};

const Dialog = ({
  type,
  icon,
  footer,
  content,
  onCancel,
  onConfirm,
  className,
  contentClassName = '',
  isOpen,
  withIcon = true,
  okButtonText = 'ok',
  disableCancelButton,
  cancelButtonText = 'cancel',
  hideCloseButton,
  isHideFooter,
  buttonsIsLoading = false,
}) => {
  useLockBody(true);

  const { src, alt, imgClassName } = dialogImages[type] || {};

  return (
    <Portal isOpen={isOpen}>
      <div className={classNames('popup-wrapper dialog', className)}>
        <div className="container dialog">
          <div className="header-part">
            {!hideCloseButton && <Icon label="close" onClick={onCancel} />}
          </div>
          <div className={classNames('dialog-content', contentClassName)}>
            {withIcon && (
              <div className="img-icon-holder">
                {icon || <img className={imgClassName} src={src} alt={alt} />}
              </div>
            )}
            <div className={classNames('text-block', { big: !withIcon })}>{content}</div>
            <div className="buttons-block vertical">
              {!isHideFooter && (
                <>
                  {footer}
                  {!footer && !disableCancelButton && (
                    <Button
                      className="transparent"
                      onClick={onCancel}
                      showSkeleton={buttonsIsLoading}
                      label={cancelButtonText}
                    />
                  )}
                  {!footer && (
                    <Button
                      className={className}
                      onClick={onConfirm}
                      label={okButtonText}
                      showSkeleton={buttonsIsLoading}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Portal>
  );
};

Dialog.propTypes = {
  icon: PropTypes.node,
  type: PropTypes.string,
  content: PropTypes.node,
  onConfirm: PropTypes.func,
  className: PropTypes.string,
  okButtonText: PropTypes.string,
  buttonsIsLoading: PropTypes.bool,
  isOpen: PropTypes.bool.isRequired,
  cancelButtonText: PropTypes.string,
  disableCancelButton: PropTypes.bool,
  footer: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
};

export default Dialog;
